import { lazy } from "react";

/** Recover once when a cached app shell references chunks from an older build. */
export function lazyPage<T extends React.ComponentType<any>>(pageKey: string, loader: () => Promise<{ default: T }>) {
  return lazy(async () => {
    const recoveryKey = `wenjing-chunk-recovery:${pageKey}`;
    try {
      const module = await loader();
      sessionStorage.removeItem(recoveryKey);
      return module;
    } catch (error) {
      if (sessionStorage.getItem(recoveryKey)) {
        sessionStorage.removeItem(recoveryKey);
        throw error;
      }
      sessionStorage.setItem(recoveryKey, "1");
      if ("serviceWorker" in navigator) {
        const registration = await navigator.serviceWorker.getRegistration().catch(() => undefined);
        await registration?.update().catch(() => undefined);
        registration?.waiting?.postMessage({ type: "SKIP_WAITING" });
      }
      window.location.reload();
      return new Promise<never>(() => undefined);
    }
  });
}
